import './NotFoundPage.scss';

export const NotFoundPage = () => (
  <main className="not-found-page">
    <h1>Page not found &#x1F613;</h1>
  </main>
);
